import { ReactComponent as PreviewUnavailableIcon } from './previewUnavailable.svg'
import Styles from './EmptyPreview.module.scss'
import cx from 'classnames'

interface Props {
  className?: string
}

export const PreviewUnavailable = ({ className }: Props) => (
  <div className={cx(Styles.empty, className)}>
    <PreviewUnavailableIcon />
    <div className={Styles.emptyText}>Preview isn't available</div>
  </div>
)
